<script setup>
import { computed, ref, watch } from "vue";

import Modal from "@/components/Modal";

const props = defineProps(["menuType", "buttonStyle"]);
const emit = defineEmits(["addCategory"]);

const input = ref(null);

const modalOpen = ref(false);

watch(input, (value) => {
  if (input.value) {
    input.value.focus();
  }
});

function toggleModal() {
  modalOpen.value = !modalOpen.value;
}

function addCategory(type, catName) {
  if (!catName) return;
  emit("addCategory", type, catName);
  toggleModal();
}
</script>

<template>
  <div class="link-add" @click="modalOpen = true">Add Category <span>+</span></div>
  <Modal :active="modalOpen" @toggle="toggleModal">
    <div class="category-add">
      <input type="text" placeholder="Category Name" ref="input" @keyup.enter="addCategory(menuType, input.value)" />
      <button @click="addCategory(menuType, input.value)">Add Category</button>
    </div>
  </Modal>
</template>

<style scoped lang="scss">
@import '../../../scss/partials/variables';

.category-add {
  display: flex;
}

input {
  margin: 0;
}

button {
  white-space: nowrap;
}

@media screen and (max-width: $breakpoint-xs ) {
  .link-add {
    margin-bottom: 10px;
  }
}
</style>
